<label [class.disabled]="disabled || !available" [class.checked]="check" [class.noborderd]="!borderd">
    <div class="bullet-icon">
        <i class="flaticon-exclamation" *ngIf="!available"></i>
        <!-- <i class="flaticon-tick" *ngIf="available"></i> -->
        <img class="img-UnCheck" src="assets/images/UnCheck.png" *ngIf="available" width="20px" alt="" srcset="">
        <img class="img-tick" src="assets/images/check.png" *ngIf="available" width="20px" alt="" srcset="">
    </div>
    <input type="checkbox" [(ngModel)]="check" [disabled]="disabled" (change)="change()">
    <span class="label"> {{label}}</span>
</label>
